// extracted by mini-css-extract-plugin
module.exports = {"loader":"SmallPreloader_loader__13_ZB"};